import React, {useEffect, useState} from "react";
import "../../../Dashboard/Dashboard.css";
import "../../../Dashboard/Sidebar.js";
import Header from "../../../layout/header";
import BottomMenu from "../../../layout/bottomMenu";
import SuccessModal from "../../../CustomModal/Success";
import FailedModal from "../../../CustomModal/Failed";
import DashboardMenu from "../../../layout/dashboardMenu";
import Loader from "../../../../Loader/Loader";
import useLatLng from "../../../../hooks/uselatlng/uselatlng";
import {toast} from "react-toastify";
import SearchLocation from "../../../searchLocation/searchLocation";
import useCurrentLocation from "../../../../hooks/currentlocation/useCurrentlocation";
import "./create-dealer.css";
const CreateDealer = ({
  history = null,
  saveLead,
  lead = [],
  getLeadById,
  leadById = [],
  match,
  searchDealerMaster,
  searchMasterDealer = []
}) => {
  const islatlng = useCurrentLocation();
  const [inputData, SetInputData] = useState([
    {
      //   name: "",
      //   contact: "",
      //   email: "",
      account_name: "",
      lat: "",
      long: "",
      address: "",
      type: "",
      meta_data:{}
      //   designation: "",
    },
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const [countToOpenModal, setCountToOpenModal] = useState(0);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
  const [isFailedModalOpen, setIsFailedModalOpen] = React.useState(false);
  const [userMessage, setUserMessage] = useState("");
  const [redirectUrl, setRedirectUrl] = useState("");
  const [isAllow, setIsAllow] = useState(false);
  const [searchValue, setSearchValue] = useState('')
  const [mapLocation, setMapLocation] = useState({
    address: "Delhi",
    lat: 0,
    lng: 0,
  });
  const [lat, setLat] = useState("");
  const [long, setLong] = useState("");
  const [pocDetails, addPOCDetails] = useState([
    {
      name: "",
      designation: "",
      email: "",
      number: "",
      other_designation: ""
    },
  ]);

  const [dealerType, setDealerType] = useState("")
  const [currentAddress, setCurrentAddress] = useState("");
  const [isCurrentAddressChange, setIsCurrentAddressChange] = useState(false);

  useEffect(() => {
    if (match?.params.id !== undefined) {
      (async () => {
        setIsLoading(true);
        await getLeadById(match?.params.id);
        setIsLoading(false);
      })();
    }
  }, []);

  const [isInputError, setIsInputError] = useState({
    latError: false,
    longError: false,
    pinError: false,
    crl: false,
    isPinNotFound: false,
  });

  const [optOption, setOptOption] = useState({
    address2: "",
    currentLocation: "",
  });

  useEffect(() => {
    if (islatlng === false) {
      setIsAllow(true);
    } else {
      setIsAllow(false);
    }
    var lati = Number(islatlng?.lat);
    var langi = Number(islatlng?.lng);
    if (!isNaN(lati) && !isNaN(langi)) {
      setMapLocation({
        address: "Delhi6",
        lat: Number(islatlng?.lat),
        lng: Number(islatlng?.lng),
      });
    }
  }, [islatlng]);

  useEffect(() => {
    if (leadById && leadById?.data !== undefined) {

      let list = [...inputData];
      list[0]["name"] = leadById?.data?.name;
      list[0]["email"] = leadById?.data?.email;
      list[0]["contact"] = leadById?.data?.number;
      list[0]["account_name"] = leadById?.data?.account_name;
      setOptOption({...optOption, currentLocation: leadById?.data?.address});
      list[0]['address'] = leadById?.data?.address
      setCurrentAddress(leadById?.data?.address)
      list[0]["designation"] = leadById?.data?.designation;
      list[0]["other_designation"] = leadById?.data?.other_designation;
      setLong(leadById?.data?.longitude);
      setLat(leadById?.data?.latitude);
      list[0]["lat"] = leadById?.data?.latitude;
      list[0]["long"] = leadById?.data?.longitude;
      SetInputData(list);

    }

    if (leadById?.data?.lead_poc_details !== null && leadById?.data?.lead_poc_details !== undefined && Object.keys(leadById?.data?.lead_poc_details).length > 0) {
      addPOCDetails(leadById?.data?.lead_poc_details)
    }
  }, [leadById]);

  const handleInputValue = (val, key, metaKey = '', e) => {
    const list = [...inputData];
    if (key === 'meta_data') {
      if (e.target !== undefined && e.target.selectedOptions !== undefined) {
        list[0][key][metaKey] = e.target.selectedOptions[0].text
        list[0][key][metaKey + "_id"] = val
      }
    } else {
      list[0][key] = val;
    }
    SetInputData(list);
  };

  const handleRemovePOC = (e, index) => {
    const list = [...pocDetails];
    list.splice(index, 1);
    addPOCDetails(list);
    e.preventDefault();
  };

  const handleAddPOC = () => {
    addPOCDetails([
      ...pocDetails,
      {
        name: "",
        designation: "",
        other_designation: "",
        email: "",
        number: "",
        is_kdm: false,
      },
    ]);
  };

  useEffect(() => {
    setIsFailedModalOpen(false);
    setIsSuccessModalOpen(false);
    if (parseInt(lead?.status) === 200) {
      setCountToOpenModal(countToOpenModal + 1);
      setIsSuccessModalOpen(true);
      setUserMessage(lead?.message);
    } else if (lead?.status !== undefined && lead?.status !== 200) {
      setCountToOpenModal(countToOpenModal + 1);
      setIsFailedModalOpen(true);
      setUserMessage(lead?.message);
    }
  }, [lead]);

  // const successCallback = (position) => {
  //     console.log(position);
  // };

  // const errorCallback = (error) => {
  //     console.log(error);
  //     toast.error('Please enable your location');
  // };

  console.log("TESTING KDM: ", pocDetails);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let list = [...inputData];
    list[0]["lat"] = lat;
    list[0]["long"] = long;
    if (list[0]["long"] == null || list[0]["lat"] == null) {
      toast.error("Please enable your location");
      //navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
      return false;
    }
    list[0]["type"] = "dealer";
    if(dealerType !== ''){
      list[0]['meta_data']['dealer_type'] = dealerType
    } else {
      delete list[0]['meta_data']
    }
    list[0]["pocDetails"] = pocDetails;
    if (match?.params?.id !== undefined) {
      list[0]["id"] = match?.params.id;
    }
    list['is_address_change']= isCurrentAddressChange;

    // Check for duplicate designations among POCs
    const designations = new Set();
    let hasDuplicate = false;
    pocDetails.forEach((poc) => {
      if (designations.has(poc.designation)) {
        hasDuplicate = true;
        return;
      }
      designations.add(poc.designation);
    });

    if (hasDuplicate) {
      toast.error("Please ensure each POC has a unique designation.");
      return false;
    }

    // console.log('List Data:', list[0]);
    // return false;
    setIsLoading(true);
    await saveLead(list[0]);
    setIsLoading(false);
    setRedirectUrl("dealer-lead-list/");
  };

  const handleCurrentLocationBlur = (latlng = null) => {
    if (latlng !== null && latlng !== undefined) {
      let list = [...inputData];
      list[0]["lat"] = latlng?.lat;
      list[0]["long"] = latlng?.lng;
      SetInputData(list);
      setLong(latlng?.lng);
      setLat(latlng?.lat);
    }
  };

  const handleCurrentLocationChange = (value) => {
    setOptOption({...optOption, currentLocation: value});
    // if(!isEdit){
    //     handleInput(value, 'address_1')
    // }
    if(currentAddress != value){
      setIsCurrentAddressChange(true)
    } else {
      setIsCurrentAddressChange(false)
    }
    handleInputValue(value, "address");
  };

  const handleSetCurrentLatAndLond = () => {
    let list = [...inputData];
    list[0]["lat"] = islatlng?.lat;
    list[0]["long"] = islatlng?.lng;
    SetInputData(list);
    setLat(islatlng?.lat);
    setLong(islatlng?.lng);
  };

  const handlePocInput = (val, index, i) => {
    const list = [...pocDetails];
    if (list[i]) { // Ensure the item at index i exists
      list[i][index] = val;
      addPOCDetails(list);
    }
  };


  const handleSearch = async () => {
    if(dealerType === ''){
      toast.warning("Select dealer type")
      return false
    }
    if (searchValue === '') {
      return false
    }
    setIsLoading(true)
    await searchDealerMaster(searchValue, dealerType)
    setIsLoading(false)
  }

// const handlePocInput = (val, index, i) => {
//     const list = [...pocDetails];
//     if (list[i]) {
//       if (index === "designation" && val === "Other") {
//         const inputValue = document.getElementById(`inputField${i}`).querySelector("input").value;
//         list[i][index] = inputValue;
//       } else {
//         list[i][index] = val;
//       }
//       addPOCDetails(list);
//     }
//   };

  return (
      <>
        <SuccessModal
            isOpen={isSuccessModalOpen}
            msg={userMessage}
            url={redirectUrl}
        />

        <FailedModal
            isOpen={isFailedModalOpen}
            msg={userMessage}
            countToOpenModal={countToOpenModal}
        />

        {/*<Sidebar/>*/}
        {/* section start  */}
        <Loader isLoading={isLoading}/>
        <div id="wrapper">
          <DashboardMenu/>
          <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">
              <Header
                  title={
                    match?.params?.id !== undefined ? "Edit Dealer" : "Add Dealer"
                  }
              />

              {/*BODY*/}

              <div className="container-fluid">
                {/*Heading*/}
                <div className="d-sm-flex align-items-center justify-content-between">
                  <h1 className="h3 mb-0 text-black-100 hide">Add Dealer</h1>
                </div>

                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-0 bg-white">
                        <div className="div-com-header"></div>
                        <div className="card-body">
                          <div className="user">
                            <div className="form-group row">
                              {(leadById?.data?.meta_data === null || leadById?.data?.meta_data[0]?.master_dealer_type === undefined) ?
                                <>
                                  <div
                                      className="col-md-6 float-field ">
                                    <select
                                        className="form-control form-control-user"
                                        onChange={(e) => {
                                          setDealerType(e.target.value)
                                        }}
                                        required
                                    >
                                      <option>Select Dealer</option>
                                      <option value="VERIFIED">Verified</option>
                                      <option value="UNVERIFIED" >Unverified</option>
                                    </select>
                                    <label
                                        className="large-label float-lb">
                                      Dealer Type <i
                                        className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                  </div>
                                  <div className="col-md-6 col-sm-6 d-flex">
                                    <form className="form-inline mr-auto w-100 navbar-search">
                                      <div className="d-flex w-100">
                                        <input type="text"
                                               className="form-control bg-light border-0 small list-filter"
                                               placeholder={`Search ${dealerType.toLocaleLowerCase()} Dealer...`}
                                               aria-label="Search"
                                               aria-describedby="basic-addon2"
                                               onChange={(e) => {
                                                 setSearchValue(e.target.value)
                                               }}
                                        />
                                        {/*<div className="remove-search-filter">*/}
                                        {/*  <i className="fa fa-times" aria-hidden="true" ></i>*/}
                                        {/*</div>*/}
                                        <div className="btn-search">
                                          <button
                                              className="btn btn-primary lh-32 border-left-tr-tb"
                                              type="button"
                                              onClick={(e) => handleSearch()}
                                          >
                                            <i className="fas fa-search fa-sm"></i>
                                          </button>
                                        </div>
                                      </div>
                                    </form>
                                  </div>

                                  <div
                                      className="col-md-6 float-field ">
                                    <select
                                        className="form-control form-control-user"
                                        onChange={(e) => {
                                          handleInputValue(e.target.value, "meta_data",'master_dealer_type', e);
                                        }}
                                        required={true}
                                    >
                                      <option>Select Master Dealer</option>
                                      {searchMasterDealer.length > 0 && searchMasterDealer.map((val, i) => {
                                        return (
                                            <>
                                              <option value={val?.id}>{val?.company_trade_name}</option>
                                            </>
                                        )
                                      })}
                                      <label
                                          className="large-label float-lb">
                                        Dealer <i
                                          className="bi bi-asterisk astrick-icon"></i>
                                      </label>
                                    </select>
                                  </div>
                                </>
                                  :
                                  <>
                                    <div className="col-md-6 float-field ">
                                      <input
                                          type="text"
                                          className="form-control form-control-user"
                                          required
                                          value={leadById?.data?.meta_data[0]?.master_dealer_type}
                                          disabled={true}
                                      />

                                      <label className="large-label float-lb">
                                        Dealer Master Name
                                        <i className="bi bi-asterisk astrick-icon"></i>
                                      </label>
                                    </div>
                                  </>
                              }

                                <div className="col-md-6 float-field ">
                                  <input
                                      type="text"
                                      className="form-control form-control-user"
                                      placeholder=" "
                                      onChange={(e) => {
                                        handleInputValue(
                                            e.target.value,
                                            "account_name"
                                        );
                                      }}
                                      required
                                      value={inputData[0]?.account_name}
                                  />

                                  <label className="large-label float-lb">
                                    Dealer Name{" "}
                                    <i className="bi bi-asterisk astrick-icon"></i>
                                  </label>
                                </div>

                                <SearchLocation
                                    handleCurrentLocationBlur={
                                      handleCurrentLocationBlur
                                    }
                                    isError={isInputError.crl}
                                    value={optOption.currentLocation}
                                    handleCurrentLocationChange={
                                      handleCurrentLocationChange
                                    }
                                    label={"Address"}
                                    // setPincodeValue={setPincodeValue}
                                />
                                <div className="col-md-6 float-field ">
                                  <input
                                      type="number"
                                      className="form-control form-control-user"
                                      placeholder=" "
                                      onChange={(e) => {
                                        handleInputValue(lat, "lat");
                                      }}
                                      required
                                      value={inputData[0]?.lat}
                                  />

                                  <label className="large-label float-lb">
                                    Latitude{" "}
                                    <i className="bi bi-asterisk astrick-icon"></i>
                                  </label>
                                </div>
                                <div className="col-md-6 float-field ">
                                  <input
                                      type="number"
                                      className="form-control form-control-user"
                                      placeholder=" "
                                      onChange={(e) => {
                                        handleInputValue(long, "long");
                                      }}
                                      required
                                      value={inputData[0]?.long}
                                  />

                                  <label className="large-label float-lb">
                                    Longitude{" "}
                                    <i className="bi bi-asterisk astrick-icon"></i>
                                  </label>
                                </div>

                                <div className="col-md-12">
                                  <div
                                      className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                    <h1 className="h3 mb-0 text-black-100">
                                      POC Details
                                    </h1>
                                  </div>
                                  <div className="mb-4 bg-white">
                                    <div className="hide card-header bg-lightGreen-active">
                                      POC Details
                                    </div>
                                    <div className="card-body">
                                      <div className="user">
                                        <div className="form-group row">
                                          {pocDetails && pocDetails.map((val, i) => {
                                            return (
                                                <>
                                                  <div
                                                      className="col-md-6 float-field ">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-user"
                                                        placeholder=" "
                                                        onChange={(e) => {
                                                          handlePocInput(
                                                              e.target.value,
                                                              "name",
                                                              i
                                                          );
                                                        }}
                                                        required
                                                        value={val?.name}
                                                    />
                                                    <label
                                                        className="large-label float-lb">
                                                      Poc Name{" "}
                                                      <i className="bi bi-asterisk astrick-icon"></i>
                                                    </label>
                                                  </div>
                                                  <div
                                                      className="col-sm-6 float-field">
                                                    <input
                                                        type="email"
                                                        className="form-control form-control-user"
                                                        placeholder=" "
                                                        onChange={(e) => {
                                                          handlePocInput(
                                                              e.target.value,
                                                              "email",
                                                              i
                                                          );
                                                        }}
                                                        required
                                                        value={val?.email}
                                                    />
                                                    <label
                                                        className="large-label float-lb">
                                                      Email Id{" "}
                                                      <i className="bi bi-asterisk astrick-icon"></i>
                                                    </label>
                                                  </div>
                                                  <div
                                                      className="col-sm-6 float-field">
                                                    <input
                                                        type="number"
                                                        className="form-control form-control-user"
                                                        placeholder=" "
                                                        onChange={(e) => {
                                                          const inputValue =
                                                              e.target
                                                                  .value;
                                                          const mobileNumber =
                                                              inputValue.replace(
                                                                  /\D/g,
                                                                  ""
                                                              );
                                                          const trimmedMobileNumber =
                                                              mobileNumber.slice(
                                                                  0,
                                                                  10
                                                              );
                                                          e.target.value =
                                                              trimmedMobileNumber;
                                                          handlePocInput(
                                                              trimmedMobileNumber,
                                                              "number",
                                                              i
                                                          );
                                                        }}
                                                        required
                                                        value={val?.number}
                                                        pattern={"[1-9]{1}[0-9]{9}"}
                                                    />
                                                    <label
                                                        className="large-label float-lb">
                                                      Mobile Number{" "}
                                                      <i className="bi bi-asterisk astrick-icon"></i>
                                                    </label>
                                                  </div>

                                                  <div
                                                      className="col-md-6 float-field ">
                                                    <select
                                                        className="form-control form-control-user"
                                                        onChange={(e) => {
                                                          handlePocInput(e.target.value, "designation", i);
                                                        }}
                                                        required={true}
                                                        value={val?.designation}
                                                    >
                                                      <option value="">Select
                                                        New Meeting With
                                                      </option>
                                                      <option
                                                          value={"Owner"}>Owner
                                                      </option>
                                                      <option
                                                          value={"VP"}>VP
                                                      </option>
                                                      <option
                                                          value={"GM"}>GM
                                                      </option>
                                                      <option
                                                          value={"Sale Manager"}>Sale
                                                        Manager
                                                      </option>
                                                      <option
                                                          value={"Marketing Manager"}>Marketing
                                                        Manager
                                                      </option>
                                                      <option
                                                          value={"RTO Head"}>RTO
                                                        Head
                                                      </option>
                                                      <option
                                                          value={"Other"}>Other
                                                      </option>
                                                    </select>
                                                    <label
                                                        className="large-label float-lb">
                                                      Designation <i
                                                        className="bi bi-asterisk astrick-icon"></i>
                                                    </label>
                                                  </div>
                                                  {pocDetails[i]['designation'] === 'Other' &&
                                                      <div
                                                          className="col-sm-6 float-field">
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-user"
                                                            placeholder=" "
                                                            onChange={(e) => {
                                                              handlePocInput(e.target.value, "other_designation", i);
                                                            }}
                                                            required
                                                            value={val?.other_designation}

                                                        />
                                                        <label
                                                            className="large-label float-lb">
                                                          Designation <i
                                                            className="bi bi-asterisk astrick-icon"></i>
                                                        </label>
                                                      </div>
                                                  }
                                                  <div className="col-md-6 checkbox-wrapper">
                                                    <input 
                                                      type="checkbox" 
                                                      id={`vehicle-${i}`} 
                                                      name={`vehicle-${i}`} 
                                                      className="checkbox-input" 
                                                      onChange={(e) => {
                                                        handlePocInput(e.target.checked, "is_kdm", i);
                                                      }}                                                  
                                                    />
                                                    <label htmlFor={`vehicle-${i}`} className="checkbox-label">
                                                      Is KDM ?
                                                    </label>
                                                  </div>

                                                  <div
                                                      className="btn-box mb-4"
                                                      style={{width: "100%"}}
                                                  >
                                                    {pocDetails.length !== 1 && (
                                                        <>
                                                          <button
                                                              onClick={(e) =>
                                                                  handleRemovePOC(e, i)
                                                              }
                                                              className="btn btn-sm btn-danger ml-3 btn-ar"
                                                          >
                                                            Remove
                                                          </button>
                                                        </>
                                                    )}
                                                    {pocDetails.length - 1 === i && (
                                                        <button
                                                            className="btn btn-sm btn-primary ml-3 btn-ar"
                                                            onClick={() => handleAddPOC()}
                                                        >
                                                          Add
                                                        </button>
                                                    )}
                                                  </div>
                                                </>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-12 col-sm-12 mt-4">
                                  <a
                                      className="btn btn-primary btn-user btn-block submit-btn"
                                      onClick={handleSetCurrentLatAndLond}
                                      style={{backgroundColor: "lightslategrey"}}
                                  >
                                    Set Current Location Lat And Long
                                  </a>
                                </div>
                                {/*<div className="col-md-6 float-field ">*/}

                                {/*<textarea*/}
                                {/*       className="form-control form-control-user"*/}
                                {/*       placeholder=" Address *"*/}
                                {/*       onChange={(e) => {*/}
                                {/*           handleInputValue(e.target.value, 'address')*/}
                                {/*       }}*/}
                                {/*       required*/}
                                {/*       value={inputData[0]?.address}*/}
                                {/*       min={4}*/}
                                {/*       max={15}*/}
                                {/*/>*/}
                                {/*</div>*/}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 mt-4">
                      <button className="btn btn-primary btn-user btn-block submit-btn">
                        {match?.params?.id !== undefined ? "Update" : "Submit"}
                      </button>
                    </div>
                </form>
                <img src="../img/leads.gif" width="90%"/>
              </div>
            </div>
          </div>

          <BottomMenu/>
        </div>
        {/* section ends */}
      </>
);
};
export default CreateDealer;
